import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 外部エントリーフォーム - 外部サービス - 内部サービス紐づけ一覧取得
export async function getOutsideEntryFormServiceInsideServices(id: string) {
  try {
    const path = "outsideEntryFormServiceInsideServices";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return {
      sudDatas: response.data.fetch_data,
      serviceDatas: response.data.service_data,
    };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// 外部エントリーフォーム - 外部サービス - 内部サービス紐づけ登録
export async function postOutsideEntryFormServiceInsideServices(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "outsideEntryFormServiceInsideServices";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
